import {
  Avatar,
  Box,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { supabase } from "superbase/auth";
import { SidebarResponsive } from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import React from "react";
import { FaEthereum, FaUser } from "react-icons/fa";
import { sidebarLinks as routes } from "routes/urls";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { urls } from "routes/urls";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedAssistantId } from "store/slices/admin";

const AdminNavbarLinks = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const toast = useToast();
  const adminDetails = useSelector((state) => state.admin.adminDetails);
  // console.log('admin details', adminDetails);
  
  const selectedAssistantId = useSelector(
    (state) => state.admin.selectedAssistantId
  );
  const { secondary } = props;

  // Chakra Color Mode
  const navbarIcon = useColorModeValue("black.900", "white");
  let mainMenuBg = useColorModeValue("white", "rgba(255,255,255,0.1)");
  let menuBg = useColorModeValue("white", "#323232");
  let menuListBg = useColorModeValue("secondaryGray.400", "#c7c7c7");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const ethColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
  const ethBox = useColorModeValue("white", "navy.800");
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );

  const handleLogout = async () => {
    Cookies.remove("token");
    const { error } = await supabase.auth.signOut();
    if (error) {
      toast({
        title: error.message || "Logout failed",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
    navigate(urls.signIn);
  };
  const handleAddNewAssistant = () => {
    navigate(`/assistants/?add-new=true`);
  };

  return (
    <Flex
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      bg={mainMenuBg}
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
      p="10px"
      borderRadius="30px"
      boxShadow={shadow}
    >
      <Flex
        bg={ethBg}
        display={secondary ? "flex" : "none"}
        borderRadius="30px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      >
        <Flex
          align="center"
          justify="center"
          bg={ethBox}
          h="29px"
          w="29px"
          borderRadius="30px"
          me="7px"
        >
          <Icon color={ethColor} w="9px" h="14px" as={FaEthereum} />
        </Flex>
        <Text
          w="max-content"
          color={ethColor}
          fontSize="sm"
          fontWeight="700"
          me="6px"
        >
          1,924
          <Text as="span" display={{ base: "none", md: "unset" }}>
            {" "}
            ETH
          </Text>
        </Text>
      </Flex>
      <SidebarResponsive routes={routes} />
      <Menu>
        <MenuButton p="0px">
          <Icon
            mt="6px"
            as={FaUser}
            color={navbarIcon}
            w="30px"
            h="30px"
            me="10px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          zIndex={1001}
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              Assistants
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px" gap={2}>
            {adminDetails?.assistant_admins?.assistants?.map((assistant) => (
              <MenuItem
                key={assistant?.id}
                bgColor={assistant?.id === selectedAssistantId && "black.900"}
                color={assistant?.id === selectedAssistantId && "white"}
                borderRadius="8px"
                px="14px"
                id={assistant?.id}
                onClick={() => dispatch(setSelectedAssistantId(assistant?.id))}
              >
                <Text fontSize="sm">{assistant?.name}</Text>
              </MenuItem>
            ))}
            <Box borderTop="1px solid" borderColor={borderColor}>
            <MenuItem px='14px' borderRadius='8px' mt={3} justifyContent='center' bg={menuListBg} onClick={handleAddNewAssistant}>
            <Text color='black' fontWeight={500}>Add new</Text>
            </MenuItem>
            </Box>
          </Flex>
        </MenuList>
      </Menu>

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: "pointer" }}
            color="white"
            name={adminDetails?.name ? adminDetails?.name : 'Default User'}
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              👋&nbsp; Hey {adminDetails?.name}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px" gap="5px">
            <MenuItem
              _hover={{ bg: "secondaryGray.300" }}
              _focus={{ bg: "secondaryGray.300" }}
              borderRadius="8px"
              px="14px"
              bg={menuListBg} // Default background color
              onClick={() => navigate(urls.settings)}
            >
              <Text
                fontSize="sm"
                color="black" // Text color for better contrast
              >
                Profile Settings
              </Text>
            </MenuItem>
            <MenuItem
              _hover={{ bg: "secondaryGray.300" }}
              _focus={{ bg: "secondaryGray.300" }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              bg={menuListBg}
              onClick={handleLogout}
            >
              <Text fontSize="sm" color="red">
                Log out
              </Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default AdminNavbarLinks;

AdminNavbarLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
